import { Action } from 'redux';
import { CarClassModel } from '../../../api/core/core.types';

export const GET_ACRISS_CODES = 'GET_ACRISS_CODES';

export interface CarClassState {
  acrissCodes: CarClassModel[];
}

export interface GetCarClassesAction extends Action {
  type: typeof GET_ACRISS_CODES;
  payload: {
    acrissCodes: CarClassModel[];
  };
}

export type CarClassActionTypes = GetCarClassesAction;